import { createFileRoute } from '@tanstack/react-router'
import { NestedReportPending } from './-components/shared/nested-report-pending'
import { ReportComponent } from './-components/report/report'
import { reportSearchDeps, prefetchReport } from '@/hooks/use-report'
import { trpc } from '@/main'

export const Route = createFileRoute('/_app/employees/$employeeId/report')({
  loaderDeps: ({ search }) => reportSearchDeps(search),
  loader: ({ context, deps, params }) => {
    context.queryClient.prefetchQuery(trpc.employees.getEmployee.queryOptions(Number(params.employeeId)))
    prefetchReport(context.queryClient, deps, params)
  },
  component: RouteComponent,
  pendingComponent: NestedReportPending,
})

function RouteComponent() {
  return <ReportComponent />
}
